import React from 'react';
import { Button, Tooltip } from '@material-ui/core';
import { ReactComponent as CloseIcon } from '../../assets/svg/close-x_blue.svg';
import { ReactComponent as InfoIcon } from '../../assets/svg/info.svg';
import useStyles from './index.style';

export default (props) => {
  const { title, ...others } = props;
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const classes = useStyles.common();
  const customTooltipClasses = useStyles.tooltip();
  const titleComponent = (
    <>
      <span>{title}</span>
      <Button className={classes.tooltipCloseButton} onClick={handleTooltipClose}>
        <CloseIcon />
      </Button>
    </>
  );

  return (
    <Tooltip
      classes={customTooltipClasses}
      data-testid="tooltip-button"
      open={open}
      title={titleComponent}
      {...others}>
      <Button
        className={classes.tooltipOpenButton}
        onClick={handleTooltipOpen}
        onMouseEnter={handleTooltipOpen}
        onMouseLeave={handleTooltipClose}>
        <InfoIcon />
      </Button>
    </Tooltip>
  );
};
